export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'CLOSE_MODAL';